import * as RestApi from 'core/network/RestApi';
import { Template } from 'models/template/Template';

export const getOffsiteTemplates = async (siteId: string) => {
  return (await RestApi.get<Template[]>(`/sites/${siteId}/templates/new`)).data.filter(p => p.channel === 'email');
};
